import React from "react";
import { sbEditable } from "@storyblok/storyblok-editable";
import { getStyleCss } from "../helper/css_style";

function RichEditor({ blok }) {
  let styles = {};

  if (blok?.custom_style?.length > 0) {
    styles = getStyleCss(blok.custom_style, styles);
  }

  return (
    <div className="container reset-default mx-auto " {...sbEditable(blok)} key={blok._uid} style={styles}>
      <style>
        {`
          .rich-editor ol, .rich-editor ul {
              list-style: revert;
              margin: revert;
              padding: revert;
          }
          .rich-editor, .rich-editor *{
              max-width : 1180px !important;
          }
                    
        `}
      </style>
      <div className="rich-editor" dangerouslySetInnerHTML={{ __html: blok.content.content }} />
    </div>
  );
}

export default RichEditor;
